import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getChallengeMissionAction = createAsyncThunk(
    'get-challenge-mission',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/allChallengeMission` ,{is_deleted : data?.is_deleted , category : data?.category , subCategory : data?.subCategory})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getChallengeMissionSlice = createSlice({
    name: 'get-challenge-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getChallengeMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getChallengeMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getChallengeMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getChallengeMissionReducer = getChallengeMissionSlice.reducer    